import { SHOW_KEY, NAME_KEY, KIND_KEY, KINDS } from "@/lib/printess/constants";
import { v4 as uuid } from "uuid";

const ActionButtons = ({ setItems }) => {
  const handleAddCategory = () => {
    setItems((prev) => [
      ...prev,
      {
        [NAME_KEY]: window.i18n.t("source_menu.defaults.category.name"),
        [KIND_KEY]: KINDS.CATEGORY,
        [SHOW_KEY]: true,
        key: uuid(),
      },
    ]);
  };

  const label = window.i18n.t("source_menu.buttons.add_category");

  return (
    <div className="palette-buttons-container">
      <button
        type="button"
        className="btn btn-lg btn-info"
        onClick={handleAddCategory}
      >
        {label}
      </button>
    </div>
  );
};

export default ActionButtons;
